import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useMediaQuery
} from '@mui/material';
import Button from '@mui/material/Button';
import {
  Edit as EditIcon,
  Trash2 as TrashIcon
} from 'react-feather';
import { useNavigate } from 'react-router-dom';
import DeleteModal from 'src/components/modal/DeleteModal';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
});

const DocumentTypeListResults = ({
  documentTypes,
  exclude,
  paginate,
}) => {
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const classes = useStyles();
  const isSmallScreen = useMediaQuery('(max-width: 768px)');
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    text: 'Tem certeza que deseja excluir este tipo de documento ?',
  });

  const excludeDocumentType = async (id) => {
    const confirm = await exclude(id);
    if (confirm) {
      setDeleteModal({
        ...deleteModal,
        open: false
      });
    }
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    paginate((newPage + 1));
  };

  const buttonEdit = (id) => {
    navigate(`/app/documentType/${id}`, { replace: true });
  };

  const deleteDocumentType = (id) => {
    setDeleteModal({
      ...deleteModal,
      id,
      open: true,
      confirm: excludeDocumentType,
      cancel: () => { }
    });
  };

  return (
    <>
      <Box sx={{ minWidth: 1050 }}>
        {isSmallScreen ? (
          <Grid
            container
            spacing={3}
          >
            {documentTypes.data.slice(0, limit).map((document) => (
              <Grid item xs={12} md={3} lg={3}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {document.name}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      onClick={() => { buttonEdit(document.id); }}
                      title="Editar"
                      fullWidth
                      variant="contained"
                      color="primary"
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      onClick={() => { deleteDocumentType(document.id); }}
                      title="Excluir"
                      fullWidth
                      variant="contained"
                      color="error"
                    >
                      <TrashIcon />
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Card>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {documentTypes.data.slice(0, limit).map((documentType) => (
                  <TableRow key={documentType.id}>
                    <TableCell sx={{ width: '70%' }}>{documentType.name}</TableCell>
                    <TableCell sx={{ width: '30%' }}>
                      <Button onClick={() => buttonEdit(documentType.id)} variant="contained" color="primary">
                        <EditIcon />
                      </Button>
                      {!documentType.deleted && (
                      <Button onClick={() => deleteDocumentType(documentType.id)} variant="contained" color="error">
                        <TrashIcon />
                      </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        )}
      </Box>
      <TablePagination
        component="div"
        count={documentTypes.meta.total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[]}
      />
      <DeleteModal modal={deleteModal} />
    </>
  );
};

DocumentTypeListResults.propTypes = {
  documentTypes: PropTypes.array.isRequired,
  exclude: PropTypes.array.isRequired,
  paginate: PropTypes.array.isRequired
};

export default DocumentTypeListResults;
